<template>
  <div>
    <search-item :key="find" @clear="clear" :showName.sync="find" @search="search" :readonly="false"></search-item>
    <div v-if="!showResult">
      <div class="flex flex-between flex-col-center history">
        <div class="op68 font500">历史搜索</div>
        <div class="del flex flex-col-center op30" v-if="historyList.length" @click="delHistory">
          <van-icon name="delete" size="18" />
          删除
        </div>
      </div>
      <div class="flex padding-10 flex-wrap" v-if="historyList.length">
        <van-tag
          v-for="item in historyList"
          :key="item"
          color="#F4F4F4"
          text-color="rgba(0,0,0,.3)"
          round
          class="tag"
          type="primary"
          @click="searchTag(item)"
        >
          <span class="tag-text">{{ item }}</span>
        </van-tag>
      </div>
    </div>
    <div v-else>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          :offset="100"
          v-model="load"
          :finished="finish"
          finished-text="没有更多了"
          @load="loadMore"
          v-if="list.length"
        >
          <div class="goodslist">
            <div class="oneheight">
              <template v-for="(item, index) in list">
                <!-- {{index%2==0&&item.itemId}} -->
                <goods-item
                  v-if="index % 2 == 0"
                  :key="item.itemId"
                  :goods="item"
                  ntype="newer"
                  c-type="search"
                  :f-index="index"
                ></goods-item>
              </template>
            </div>
            <div class="twoheight">
              <template v-for="(item, index) in list">
                <!-- {{index%2!==0&&item.itemId}} -->
                <goods-item
                  v-if="index % 2 !== 0"
                  :key="item.itemId"
                  :goods="item"
                  ntype="newer"
                  c-type="search"
                  :f-index="index"
                ></goods-item>
              </template>
            </div>
          </div>
        </van-list>
        <no-data
          desc="暂时没有搜素到您想要的结果"
          v-else
          showType="search"
        ></no-data>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import searchItem from "@/components/searchItem";
import goodsItem from "@/components/goodsItem";
import NoData from "@/components/noData.vue";
import { mapState ,mapActions} from "vuex";
export default {
  components: { searchItem, goodsItem, NoData },
  data() {
    return {
      showResult: false,
      isLoading: false, // 刷新状态
      load: false, //加载状态
      finish: false, // 是否加载结束
      page: 1,
      pageSize: 10,
      total: 0,
      find: "",
      list: [],
      historyList: [],
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => {
        console.log(state)
        return state.user.isLogin
      }
    })
  },
  async mounted() {
    await this.checkLogin()
    // console.log(mapState)
    // this.$toast(this.isLogin?1:2)
    let historyList = localStorage.getItem(this.$env + "historyList") || [];
    if(!Array.isArray(historyList)) historyList = historyList.split(',')
    this.historyList = historyList
    // console.log(this.historyList,this.isLogin);
    
    if(this.isLogin){
      this.getHistory()
    }
  },
  methods: {
    ...mapActions('user',['checkLogin']),
    /**
     * @description 执行搜索
     */
    search: function (v) {
      // console.log(v);
      this.find = v;
      this.page = 1;
      this.setHistory(v);
      // console.log("go on ");
      this.finish = false
      this.getList(null, false, true);
    },
    /**
     * @description 清除
     * // TODO:后期清除或者搜索关键字为空时显示历史搜索模块，可取消当前清除（取消按钮）
     */
    clear:function(){
      return
      // this.find = ''
      // this.showResult = false
    },
    /**
     * @description 点击标签搜索
     */
    searchTag:function(v){
      this.find = v
      this.sendStatics('event_history_search',{currentUrl:27,module:72,historySearch:v})
      this.getList(null, false, true);
    },
    /**
     * @description 刷新
     */
    onRefresh: function () {
      this.isLoading = true;
      this.page = 1
      this.getList(null, false, true);
    },
    /**
     * @description 加载更多
     */
    loadMore: function () {
      if (this.list.length >= this.total) {
        this.finish = true;
        this.load = false;
        return;
      }
      this.page++;
      // this.load = true
      this.getList(null, true, false);
    },
    /**
     * @description 获取历史记录
     */
    getHistory: function () {
      if (this.isLogin) {
        const memberId = localStorage.getItem(this.$env + "memberId");
        this.$service.searchHistory({ customerId: memberId }).then((res) => {
          console.log("getHistory", res);
          this.historyList = res.result
          localStorage.setItem(this.$env+'historyList',res.result)
        });
      }
    },
    /**
     * @description 清空历史记录
     */
    delHistory:function(){
      this.$dialog.confirm({
        title:'提示',
        message:'是否确定清空历史搜索记录?'
      }).then(()=>{
        localStorage.setItem(this.$env+'historyList',[])
        this.historyList = []
        if(this.isLogin){
          this.recordHistory()
        }
        this.$toast.success('删除成功')
      })
    },
    setHistory: function (v) {
      try{
        if (!v && v !== 0) return;
        let list = localStorage.getItem(this.$env + "historyList") || [];
        if(!Array.isArray(list)) list=[...(list).split(',')]
        if (!list.includes(v)) {
          // 如果超过12条搜索记录则从数组开头删除一个
          if (list.length >= 12) list.shift();
          list.push(v);
          this.historyList = list;
          console.log(list)
          localStorage.setItem(this.$env + "historyList", list);
          this.recordHistory();
        }
      }catch(e){
        console.log(e)
      }
    },
    /**
     * @description 同步历史记录
     */
    recordHistory: function () {
      const param = {
        customerId: localStorage.getItem(this.$env + "memberId"),
        records: this.historyList,
      };
      this.$service.searchRecord(param).then((res) => {
        console.log("record", res);
      });
    },
    /**
     * @description 获取查询数据
     */
    getList: function (param, isMore, isRefresh) {
      const params = {
        currentPage: this.page,
        pageSize: this.pageSize,
        find: this.find,
      };
      if (param) Object.assign(params, param);
      this.$service
        .search(params)
        .then((res) => {
          console.log(res);
          if (isRefresh) this.isLoading = false;
          if (isMore) this.load = false;
          if (res.status == 200) {
            this.showResult = true;
            if (!res.result.data) res.result.data = [];
            const list = this.list;
            if (isMore) this.list = [...list, ...res.result.data];
            else this.list = res.result.data;
            this.total = res.result.total;
          } else {
            this.$toast("请求错误");
          }
        })
        .catch((e) => {
          this.$toast("error:请求错误");
          if (isRefresh) this.isLoading = false;
          if (isMore) this.load = false;
        });
    },
  },
};
</script>
<style lang="less">
.goodslist {
  padding: 0.2667rem 0;
  margin: 0 0.1333rem;
  display: flex;
  justify-content: space-between;
}
.oneheight {
  flex: 1;
}
.twoheight {
  flex: 1;
}
.history {
  margin-top: 15px;
  padding: 0 10px;
  font-size: 14px;
  .del {
    font-size: 12px;
  }
}
.tag {
  margin-right: 10px;
  margin-top: 10px;
  .tag-text {
    padding: 3px 10px;
  }
}
</style>